function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// import Storage from '../../utils/storage'
// import Keys from '../../keys'
var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, [{
    key: "execute",
    value: function execute(properties, component) {
      // console.log(properties['token'])
      // Storage.setLocal(Keys.Db.csrfToken, properties['token'])
      Utils.dom.setCsrf(properties["token"]);
      Action.execute(properties["onSave"], component);
    }
  }]);

  return _default;
}();

export { _default as default };